








import Vue from 'vue';
import Component from 'vue-class-component';
import '../styles/footer.scss';

@Component

export class AreaFooter extends Vue {
}

export default AreaFooter;
